import React from 'react';
import './chat-new-messages-indicator.scss';

interface IProps {
  isVisible: boolean;
  onClick: () => void;
}

const ChatNewMessagesIndicator: React.FC<IProps> = ({ isVisible, onClick }) => {
  return isVisible
    ? (<div className='chat-new-messages-indicator' onClick={onClick}>
      <span>New Messages</span>
    </div>)
    : null;
};

export { ChatNewMessagesIndicator };
